import styled from 'styled-components';
import { medias, colors } from 'assets/styled/tokens';
import lupaIconSvg from 'assets/icons/magnifying.svg';
import updateIconSvg from 'assets/icons/update.svg';
import { Button } from 'components';
import ReactPaginate from 'react-paginate';

export const Paginate = styled(ReactPaginate).attrs({
  className: 'paginationBtn',
  activeClassName: 'paginationActive',
  previousLinkClassName: 'previousBtn',
  nextLinkClassName: 'nextBtn',
  pageLinkClassName: 'pageBtn',
})`
  height: 40px;
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    margin: 4px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    color: #888888;
    cursor: pointer;

    &:hover {
      color: #1e1e1e;
      background-color: #f5f3f1;
    }
  }
  .paginationActive {
    color: #1e1e1e;
    background-color: #f5f3f1;
    font-weight: 700;
  }
  .previousBtn {
    display: inline-block;
    position: relative;
    z-index: 1;
    padding: 0.2em 0.8em 0.2em 0.8em;
    margin: -2em;
  }
  .nextBtn {
    display: inline-block;
    position: relative;
    z-index: 1;
    padding: 0.2em 0.8em 0.2em 0.8em;
    margin: -2em;
  }
  .pageBtn {
    display: inline-block;
    position: relative;
    z-index: 1;
    padding: 0.2em 0.8em 0.2em 0.8em;
    margin: -2em;
  }
`;

export const ScheduleMonitoringPage = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;
  margin: 0;
  background: ${props => props.background || 'transparent'};
`;

export const ScheduleMonitoringPageContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${colors.pampas};
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  & > div {
    margin: 23px 1.5rem 3rem 1.5rem;
  }
  @media screen and (max-width: ${medias.desktopXXl}) {
    margin-left: 180px;
  }
  @media screen and (max-width: ${medias.desktopXl}) {
    margin-left: 180px;
  }
  @media screen and (max-width: ${medias.desktopMd}) {
    margin-left: 180px;
    width: calc(100% - 180px);
  }
  @media screen and (max-width: ${medias.desktopSm}) {
    margin-left: 180px;
  }
  @media screen and (max-width: ${medias.tablet}) {
    margin-left: 180px;
  }
  @media screen and (max-width: ${medias.mobile}) {
    margin-left: 180px;
  }
`;

export const PageTitle = styled.h1`
  width: 334px;
  height: 36px;

  font-family: 'Blinker';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 36px;

  letter-spacing: 0.5px;

  color: #1e1e1e;
  margin-bottom: 34px;
  margin-top: 26px;
  margin-left: 24px;
`;

export const StyledContentWrapper = styled.div`
  width: 100%;
  display: ${props => props.display || 'flex'};
  flex-direction: ${props => props.flexDirection || 'row'};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};
  grid-column-start: ${props => props.gridColumnStart};
  gap: ${props => props.gap};
`;
export const StyledContainerFooter = styled.div`
  width: 100%;
  padding: 0px 24px 24px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const LeftContainerFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  h3 {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.3px;
    color: #1e1e1e;
  }
  h4 {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #888888;
  }
`;

export const RightContainerFooter = styled.div``;

export const TablecontainerWrapper = styled.div`
  border: 1px solid #e5e5e5;
  height: auto;
  //min-width: 100%;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  //padding-right: 24px;
  background: #ffffff;
`;
export const StyledContainerHeader = styled.div`
  background: #ffffff;
  margin: 24px 24px 24px 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // padding: 0 0 0 0;
`;

export const StyledContainerSearchBar = styled.input`
  box-sizing: border-box;
  @media screen and (max-width: ${medias.desktopXl}) {
    min-width: ${props => (props.$filter ? '393px' : '320px')};
  }
  @media screen and (max-width: ${medias.desktopMd}) {
    min-width: ${props => (props.$filter ? '252px' : '320px')};
  }
  height: 32px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding-left: 10px;
  ::placeholder {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.3px;
    color: #888888;
    padding: 6px 6px 6px 0;
    background: url(${lupaIconSvg}) no-repeat center/contain;
    background-position: right center;
    background-size: 12px;
    background-position-x: 95%;
  }
`;

export const StyledContainerFilters = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const UpdatePlansButton = styled(Button)`
  border: 1px solid #f38a00;
  border-radius: 4px;
  width: 167px;
  height: 32px;
  padding-left: 25px;
  background-color: #ffffff;
  background: url(${updateIconSvg}) no-repeat center/contain;
  background-size: 12px;
  background-position: left center;
  background-position-x: 5%;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #f38a00;
`;

export const FilterButton = styled(Button)`
  width: 101px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #1e1e1e;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const FilterRowContainer = styled.div`
  max-width: 100%;
  height: 60px;
  margin: 24px 24px 40px 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const CleanFiltersButton = styled(Button)`
  width: 156px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #c25446;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-left: 16px;
`;
